import $ from 'jquery';

// eslint-disable-next-line func-names
$('.zoom-gallery .selectors a').on('touchstart click', function (event) {
  const iframe = $('.active iframe[src*="youtube"], .active iframe[src*="vimeo"]');

  if (iframe.length) {
    iframe.attr('src', iframe.attr('src'));
  }

  $('.zoom-gallery .zoom-gallery-slide').removeClass('active');
  $('.zoom-gallery .selectors a').removeClass('active');
  $(`.zoom-gallery .zoom-gallery-slide[data-slide-id="${$(this).attr('data-slide-id')}"]`).addClass('active');
  $(this).addClass('active');
  event.preventDefault();
});
$('.zoom-gallery').on('click', '.mcs-item', function setActiveThumb() {
  MagicZoom.switchTo('zoom-v', Number($(this).attr('data-item')));
  $('.mcs-item').removeClass('active');
  $(this).addClass('active');
});



// WEBPACK FOOTER //
// ./assets/js/components/magic-zoom.js